import { Module } from 'vuex'
import { IRootState } from '@/store/types'
import { MetricsState } from './model'
import { ICurrentSupplyRes, getCurrentSupply } from '@/services/currentSupply'
import {
    getCurrentValidators,
    ICurrentValidatorRes,
} from '@/services/currentValidator'
import { getHeight, IHeightRes } from '@/services/height'
import { getPeers, IPeersRes, IPeersParams } from '@/services/peers'
import {
    getPendingValidators,
    IPendingValidatorRes,
    IPendingValidatorsParams,
} from '@/services/pendingValidators'
import { getTotalStake, ITotalStakeRes } from '@/services/totalStake'
import {
    getValidatorsAt,
    IValidatorsAtRes,
    IValidatorsAtParams,
} from '@/services/validatorsAt'

import { IBurnedFeesRes, getBurnedC } from '@/services/burned'

const defaultState: MetricsState = {
    peers: null,
    height: null,
    currentValidators: null,
    currentSupply: null,
    pendingValidators: null,
    totalStake: null,
    validatorsAt: null,
    burnedFees: null,
}

const metrics_module: Module<MetricsState, IRootState> = {
    namespaced: true,
    modules: {},
    state: defaultState,
    mutations: {
        addPeers(state, peers: IPeersRes) {
            state.peers = peers
        },
        addHeight(state, height: IHeightRes) {
            state.height = height
        },
        addValidators(state, validators: ICurrentValidatorRes) {
            state.currentValidators = validators
        },
        addSupply(state, supply: ICurrentSupplyRes) {
            state.currentSupply = supply
        },
        addPendingValidators(state, validators: IPendingValidatorRes) {
            state.pendingValidators = validators
        },
        addTotalStake(state, totalStake: ITotalStakeRes) {
            state.totalStake = totalStake
        },
        addValidatorsAt(state, validators: IValidatorsAtRes) {
            state.validatorsAt = validators
        },
        addBurnedFees(state, fees: IBurnedFeesRes) {
            state.burnedFees = fees
        },
    },
    actions: {
        async init({ dispatch }) {
            // await dispatch('updatePeers')
            await dispatch('updateHeight')
            await dispatch('updateCurrentValidators')
            await dispatch('updateCurrentSupply')
            // await dispatch('updatePendingValidators')
            await dispatch('updateTotalStake')
            // await dispatch('updateValidatorsAt')
            await dispatch('updateBurnedFees')
        },
        async updatePeers(store, param: IPeersParams) {
            const peers: IPeersRes = await getPeers(param)
            store.commit('addPeers', peers)
        },
        async updateHeight(store) {
            const heightRes: IHeightRes = await getHeight()
            store.commit('addHeight', heightRes)
        },
        async updateCurrentValidators(store) {
            const validatorsRes: ICurrentValidatorRes = await getCurrentValidators()
            store.commit('addValidators', validatorsRes)
        },
        async updateCurrentSupply(store) {
            const supplyRes: ICurrentSupplyRes = await getCurrentSupply()
            store.commit('addSupply', supplyRes)
        },
        async updatePendingValidators(store, param: IPendingValidatorsParams) {
            const pendingValidatorsRes: IPendingValidatorRes = await getPendingValidators(
                param
            )
            store.commit('addPendingValidators', pendingValidatorsRes)
        },
        async updateTotalStake(store) {
            const totalStakeRes: ITotalStakeRes = await getTotalStake()
            store.commit('addTotalStake', totalStakeRes)
        },
        async updateValidatorsAt(store, param: IValidatorsAtParams) {
            const validatorsAtRes: IValidatorsAtRes = await getValidatorsAt(
                param
            )
            store.commit('addValidatorsAt', validatorsAtRes)
        },
        async updateBurnedFees(store) {
            const burnedFeesRes: IBurnedFeesRes = await getBurnedC()
            store.commit('addBurnedFees', burnedFeesRes)
        },
    },
}

export default metrics_module
